import styled from 'styled-components';

import { Button } from '@sternum/ui';
import { mediaQueries } from '@sternum/web/config/mediaQueries';

export const Container = styled.div`
  flex: 1;
  position: relative;
`;

export const FormBox = styled.form`
  margin-top: 32px;
`;

export const ButtonRefresh = styled(Button)`
  margin-top: 16px;

  @media (${mediaQueries.lg}) {
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;
